export default "__VITE_ASSET__cCMMw52o__"